<template>
    <EmployeeTrackServiceReport></EmployeeTrackServiceReport>
</template>
<script>
    import EmployeeTrackServiceReport from '@/components/EmployeeTrackServiceReport.vue'
    export default {
        name: 'employee-track-report-service',
        components: {
            EmployeeTrackServiceReport
        }
    }
</script>